const postCodeAllowPartiallyRegex = new RegExp("^(?:[0-9]|$)(?:[0-9]|$)(?:-|$)(?:[0-9]|$){1,3}$");

export default {
    name: 'postCodeList',
    message: () => 'Podaj kody po przecinku. Mogą być niepełne. Np. 01-001,02-00,03,04-001',
    validate: input => {
        const codes = input.split(',');

        for (let code of codes) {
            if (!code || !postCodeAllowPartiallyRegex.test(code)) {
                return false;
            }
        }

        return true;
    }
}